import { useEffect, useState } from "react";
import { Env, ErrorX, store } from "static";
import { DATA_LINK, backendConnector } from "connectors";
import { IUser } from "./Interface/user.interface";
import PasswordChanger from "Components/PasswordChanger/PasswordChanger";
import EmailChanger from "Components/EmailChanger/EmailChanger";
import { Container, Card, CardContent, Avatar, Typography, TextField, Box, Grid, Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { HStack } from "Components";

const theme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          marginTop: 10,
          marginBottom: 10,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          width: "80%",
          margin: "auto",
          borderRadius: 15,
          boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          textAlign: "center",
          padding: "30px 20px",
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 100,
          height: 100,
          margin: "auto",
          marginBottom: 15,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          margin: "10px 0",
        },
      },
    },
  },
});

enum UserRoles {
  rootUser = "syva@Dev",
}

const SysUserProfile = () => {
  const [loading, setLoading] = useState(true);

  const [sysProfile, setSysProfile] = useState<IUser>();
  const [displayName, setDisplayName] = useState<string>("");
  const [emailChanged, setEmailChanged] = useState(false);

  const getProfileInfo = async () => {
    try {
      if (store.user.Username == UserRoles.rootUser) {
        setLoading(false);
        return;
      }
      const data = await backendConnector.post(DATA_LINK.SYSUserProfile, {
        username: store.user.Username,
      });
      setSysProfile(data.payload);
      setDisplayName(data.payload.UserDisplayName);
      setEmailChanged(false);
      setLoading(false);
    } catch (e) {
      store.Alert("Cannot get user info", "error");
    }
  };
  useEffect(() => {
    //Get UserProfile Info when email Changed
    getProfileInfo();
  }, [emailChanged]);

  const onSubmit = async (userData: any) => {
    try {
      let data = await backendConnector.post(DATA_LINK.UserEdit, userData);
      await getProfileInfo();
      store.isLoading(false);
      if (!data.Success) {
        ErrorX.Handle(data.payload);
        return;
      }
      store.Alert("User Profile updated successfully", "success");
      await Env.GetSysInfo();
    } catch (e) {
      store.Alert("Cannot update User Profile", "error");
    }
  };

  const renderProfile = () => {
    return (
      <ThemeProvider theme={theme}>
        <Container>
          <Card style={{ width: "100%" }}>
            <CardContent>
              <Avatar alt={sysProfile?.username} src="/static/images/avatar.jpg" />
              <Typography variant="h5" component="div">
                User Info
              </Typography>

              <Box my={1}>
                <TextField id="username" label="Username" defaultValue={sysProfile?.username} fullWidth disabled />
              </Box>

              <Box my={1}>
                <TextField id="display-name" label="Display Name" value={displayName} fullWidth onChange={(e) => setDisplayName(e.target.value)} />
              </Box>

              <Box my={1}>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <TextField id="email" label="Email" value={sysProfile?.email} fullWidth disabled />
                  </Grid>
                  <Grid item xs={4}>
                    <EmailChanger username={sysProfile?.username!} setEmailChanged={setEmailChanged} />
                  </Grid>
                </Grid>
              </Box>

              <Box my={1}>
                <TextField id="role" label="Role" defaultValue={sysProfile?.role} fullWidth disabled />
              </Box>

              <Box my={1}>
                <TextField id="last-login" label="Last Login" defaultValue={sysProfile?.lastLogin} fullWidth disabled />
              </Box>

              <Box my={1}>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <TextField id="password" label="Password" type="password" fullWidth disabled />
                  </Grid>
                  <Grid item xs={4}>
                    <PasswordChanger username={sysProfile?.username!} />
                  </Grid>
                </Grid>
              </Box>
              <Button variant="contained" color="primary" onClick={() => onSubmit({ ...sysProfile, UserDisplayName: displayName })}>
                Save
              </Button>
            </CardContent>
          </Card>
        </Container>
      </ThemeProvider>
    );
  };
  const renderRootUser = () => {
    return (
      <HStack>
        <Typography variant="h5" component="div">
          Not available for Root user
        </Typography>
      </HStack>
    );
  };
  return (
    <Box width={"100%"} height={"100%"} overflow={"auto"}>
      {!loading && (sysProfile ? renderProfile() : renderRootUser())}
    </Box>
  );
};

export default SysUserProfile;
